import type { AppointmentPatient } from '@/react-query/useAppointments';

export enum VideaNotesUIState {
  PATIENT_INFO = 'PATIENT_INFO',
  AUDIO_CAPTURE = 'AUDIO_CAPTURE',
  NOTE_GENERATION = 'NOTE_GENERATION',
  SUMMARY_RESULT = 'SUMMARY_RESULT',
  ERROR = 'ERROR',
}

export enum VoiceNotesSource {
  VOICE_NOTES_TABLE = 'VOICE_NOTES_TABLE',
  VOICE_NOTES_BUTTON = 'VOICE_NOTES_BUTTON', // Huddle + Fmx Viewer
  QUICK_NOTE = 'QUICK_NOTE',
}

export interface VideaNotesAppointmentData {
  patient?: AppointmentPatient;
  appointmentStartsAt?: string;
  standalonePatientVisitId?: string;
  estimatedVisitId?: number | null;
  unifiedId?: string;
  loggedInUser?: string;
}
